
import * as moment from 'node_modules/moment/src/moment.js';
import * as platform from 'node_modules/platform/platform.js';
import * as _ from 'node_modules/underscore/underscore.js';
import deepclone from 'node_modules/underscore.deepclone/dist/underscore.deepclone.js';
import * as bootstrap from 'node_modules/bootstrap/dist/js/bootstrap.js';
import * as Modernizr from 'node_modules/Modernizr/modernizr.custom.js';
import videojs from 'video.js';
import YouTube from 'node_modules/videojs-youtube/dist/Youtube.min.js';

import accessibility from './modules/classes/accessibility.js';
import bodyPlatform from './modules/classes/bodyPlatform.js';
import checkTab from './modules/classes/checkTab.js';
import skipToContent from './modules/classes/skipToContent.js';
import homeHeroTextSlider from './modules/classes/homeHeroTextSlider.js';
import accessibleMenu from 'applicationBlocks/autonav/templates/accessible/modules/classes/accessibleMenu.js';
import mobileMenu from 'applicationBlocks/autonav/templates/mobile/modules/classes/mobileMenu.js';
import contentFixes from './modules/classes/contentFixes.js';
import events from './modules/classes/events.js';
import accessibleYoutube from 'applicationBlocks/accessible_youtube/modules/classes/accessibleYoutube.js'

_.mixin(deepclone);
const accessibilityInst = new accessibility();
const bodyPlatformInst = new bodyPlatform();
const checkTabInst = new checkTab();
const skipToContentInst = new skipToContent();
const homeHeroTextSliderInst = new homeHeroTextSlider();
const accessibleMenuInst = new accessibleMenu();
const mobileMenuInst = new mobileMenu();
const contentFixesInst = new contentFixes();
const eventsInst = new events();

if ($('.accessible-yt-js').length) {
    const accessibleYoutubeInst = new accessibleYoutube();
}

$(function () {
    if ($('[target="_blank"]').length) {
        $('[target="_blank"]').attr('target', '_self');
    }

    function fixHomePageHeroButton() {
        let ele = $('.call-to-action-box a');
        ele.attr('aria-label', ele.text() + ' about ' + $('.large-green-text').text());
    }
});

(function($) {
    $.fn.extend({
        animateCss: function (animationName, onAnimationEnded) {
            this.addClass('animated ' + animationName);
            if ($(this).length) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend';
                var animationDuration = $(this).css('animation-duration').toLowerCase().indexOf('ms') !== -1 ? parseFloat($(this).css('animation-duration')) / 1000 : parseFloat($(this).css('animation-duration'))
                if ($(this).css('animation-delay')) {
                    var animationDelay = $(this).css('animation-delay').toLowerCase().indexOf('ms') !== -1 ? parseFloat($(this).css('animation-delay')) / 1000 : parseFloat($(this).css('animation-delay'))
                    var ele = $(this);
                    setTimeout(
                        function () {
                            if (onAnimationEnded) {
                                onAnimationEnded();
                            }
                            ele.removeClass('animated ' + animationName);
                        },
                        ((animationDuration + animationDelay) * 1000)
                    );
                }
            }
        }
    });
}( jQuery ));

/**
 * Created by John Everden on 3/7/2017.
 */
(function( $ ) {
    /**
     *
     * @param options
     * Accepts an object with the following keys
     *
     *  inViewport - function called when object is inview port takes param progress
     *  outViewport - function called when object is out of viewport but was in viewport previously @param progress
     *  progressChangedInViewport- function called when progress is changed in viewport takes @param progress
     *  progressChanged - unction called when progress is changed takes @param progress
     *  ignoreTab - Should the tab key functionality be ignored. Default false
     *  throttle - Slow the progress down - takes wait time in MS
     */
    $.fn.aeParallax = function(options) {
        var self = this,
            id =randomString(10, "A"),
            oldProgress =false,
            progress = false,
            inViewPort = false,
            ignoreTab = false;

        if (options && options.ignoreTab) {
            ignoreTab = true;
        }






        if (self.length) {
            $(window).on(
                'scroll.' + id,
                _.throttle(
                    function () {
                        setProgress(getWindowProgress());
                    },
                    options.throttle ? options.throttle : 1
                )
            );

            if (!ignoreTab) {
                $('body').keyup(function (e) {
                    var code = e.keyCode || e.which;
                    if (code == '9') {
                        if (!inViewPort) {
                            inViewPort = true;
                            if (options.inViewport) {
                                options.inViewport(1, true);
                            }
                        }
                        if (options.progressChanged) {
                            options.progressChanged(0, true);
                        }
                    }
                });
            }


            //set the progress var (when the page loads the scroll bar isn't always 0)
            setProgress(getWindowProgress());

            //If Dom element is removed let's not pollute the window
            this.on("remove", function () {
                $(window).unbind('.' + id);
            });

            function setProgress(val) {

                if (val !== oldProgress) {
                    oldProgress = progress;
                    progress = val * -1;
                    if (progress > 0 && progress < 1.0000000000000001) {
                        // Was it previously not in the view?
                        if (!inViewPort) {
                            inViewPort = true;
                            if (options.inViewport) {
                                options.inViewport(progress);
                            }
                        }
                        //If it's in the view and the option for progressChangedInViewport is defined call it
                        if (options.progressChangedInViewport) {
                            options.progressChangedInViewport(progress);
                        }
                    } else {
                        if (inViewPort) {
                            inViewPort = false;
                            if (options.outViewport) {
                                options.outViewport(progress);
                            }
                        }
                    }
                    //Is options progressChanged available for call
                    if (options.progressChanged) {
                        options.progressChanged(progress);
                    }
                }
            }

            return self;
        }
        //Based on this dom element get the current progress based on a 0-100 scale. 0 Is in viewport
        function getWindowProgress() {
            var offSet = ($(self).offset().top - $(document).scrollTop()) / $(window).height();
            return (offSet) * -1;
        }

        //Generate a random string borrowed from stackoverflow
        function randomString(len, an) {
            an = an && an.toLowerCase();
            var str = "", i = 0, min = an == "a" ? 10 : 0, max = an == "n" ? 10 : 62;
            for (; i++ < len;) {
                var r = Math.random() * (max - min) + min << 0;
                str += String.fromCharCode(r += r > 9 ? r < 36 ? 55 : 61 : 48);
            }
            return str;
        }




    };
}( jQuery ));
